@if (filterNames.length > 0) {
  <div class="project-filter-container">
    <mat-button-toggle-group
      class="project-toggle__group"
      appearance="legacy"
      name="fontStyle"
      aria-label="Font Style">
      @for (name of filterNames; track name) {
        <mat-button-toggle
          (change)="onChangeFilter($event, name)"
          [ngClass]="{'bg-green':selected}" class="toggle-btn">
          {{ name }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
}
